import { render, staticRenderFns } from "./notificationareaShared.vue?vue&type=template&id=18217d82&scoped=true&"
import script from "./notificationareaShared.vue?vue&type=script&lang=js&"
export * from "./notificationareaShared.vue?vue&type=script&lang=js&"
import style0 from "./notificationareaShared.vue?vue&type=style&index=0&id=18217d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18217d82",
  null
  
)

export default component.exports